// extracted by mini-css-extract-plugin
module.exports = {"dot":"_5eacf20f","activeDot":"_c4026c03"};